import {
  HOTEL_AUTOCOMPLETE_SECTION_FULL_LIMIT,
  HOTEL_AUTOCOMPLETE_SECTION_PREVIEW_COUNT,
} from '../constants/hotelSearch.constants';

function sliceAutocompleteSection(items, expanded) {
  const list = Array.isArray(items) ? items : [];
  if (expanded || list.length <= HOTEL_AUTOCOMPLETE_SECTION_FULL_LIMIT) {
    return { visible: list, showLoadMore: false };
  }
  return {
    visible: list.slice(0, HOTEL_AUTOCOMPLETE_SECTION_PREVIEW_COUNT),
    showLoadMore: true,
  };
}

export { sliceAutocompleteSection };
